// Configuração para URLs públicas
export const PUBLIC_URLS = {
  SITE_BASE_URL: "https://vofficer.io",
};

export const getPublicSiteUrl = (slug, path = '') => {
  return `https://${slug}.${PUBLIC_URLS.SITE_BASE_URL.replace('https://', '')}${path}`;
};